import { isMobile } from 'react-device-detect'

export const deviceDetector = () => {
  if (isMobile) return true
}
